import { useT } from '@transifex/react'
import React, { useState } from 'react'
import { Icon, WithPopover, Text } from '@lightspeed/design-system-react'
import { formatCurrencyValue } from '@vend/utilities'
import { add } from 'vend-number'
import { PromotionSummaryItem } from '../../../../../scripts/functions/sale'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../../ng-compat/hooks'
import { ViewPromotionPopover } from './ViewPromotionPopover'

interface Props {
  promotionSummary: PromotionSummaryItem[]
}

export const PromotionRow: React.FC<Props> = ({ promotionSummary }) => {
  const currentOutlet = useRegisterManager().getActiveOutlet()
  const retailer = useRetailerSettingsManager().get()
  const [showPopover, setShowPopover] = useState(false)
  const t = useT()

  if (promotionSummary.length === 0) {
    // Hide popover if the last promotion is deleted
    setShowPopover(false)
  }

  const hasMultiplePromotions = promotionSummary.length > 1
  const totalPromotionAmount = promotionSummary.reduce(
    (total, promo) => add(total, promo.total!),
    0
  )

  return (
    <>
      <WithPopover direction="left" alignment="start">
        <div
          className="vd-text-label vd-link pro-sale-promotion-link"
          onClick={() => setShowPopover(true)}
        >
          {t('{count, plural, one {Promotion} other {Promotions}}', {
            count: promotionSummary.length,
          })}
        </div>

        {showPopover && (
          <ViewPromotionPopover
            promotionSummary={promotionSummary}
            closePopover={() => setShowPopover(false)}
          />
        )}
      </WithPopover>

      <span className="vd-flex vd-flex--justify-start vd-flex--align-center vd-sale-total-line-item--sub vd-ml2">
        <Icon icon="fa-ticket" />
        <span className="pro-sale-promotion-count vd-ml1">
          {hasMultiplePromotions
            ? ` ${t('{count} promotions', {
                count: promotionSummary.length,
              })}`
            : ` ${promotionSummary[0].name}`}
        </span>
      </span>

      <Text type="label" className="sale-total-line-item--value">
        {formatCurrencyValue(
          totalPromotionAmount,
          retailer.culture,
          currentOutlet.currency,
          currentOutlet.currency_symbol
        )}
      </Text>
    </>
  )
}
